import * as React from 'react';

const LeftArrowHead = () => (
  <svg width="0.7em" height="0.7em" viewBox="0 0 8 12" fill="none">
    <path
      d="M6.5 11L1.6 6.236A.332.332 0 011.5 6a.325.325 0 01.1-.236L6.5 1"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default React.memo(LeftArrowHead);
